<ng-container *ngIf="!hideDragIcon">
  <div cdkDropList
       (cdkDropListDropped)="drop($event)">
    <section *ngFor="let actionItem of value; let i = index"
             cdkDrag
             class="config-edit-area">
      <ng-container *ngIf="actionItem.isEditing; else descriptionTmpl">
        <div class="form-area">
          <div class="form-header-actions">
            <div class="form-header-left">
              <div *ngIf="showVisibilityToggle" class="visibility-button">
                <rappider-button [icon]="isActionVisible(actionItem) ? visibilityOnIconConfig : visibilityOffIconConfig"
                                 size="small"
                                 [tooltipText]="isActionVisible(actionItem) ? 'Hide' : 'Show'"
                                 (click)="onVisibilityToggleClick(i)"></rappider-button>
              </div>
            </div>
            <div class="form-header-right">
              <rappider-button [icon]="collapseIconConfig"
                               size="small"
                               [tooltipText]="'Collapse'"
                               (click)="onCollapseClick(i)"></rappider-button>
            </div>
          </div>
        <div class="config-input-area">
          <div class="control-area">
            <nz-form-label nzRequired>
              Name
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.name"
                                (blur)="onInputBlur()"></rappider-textbox>
              <small *ngIf="tempValueSubmitted && !actionItem.name"
                     class="error">*This field can't be empty</small>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label>
              Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.text"
                                (blur)="onInputBlur()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Behavior
            </nz-form-label>
            <div class="input">
              <rappider-select [(ngModel)]="actionItem.behavior"
                               [options]="behaviorSelectOptions"
                               (blur)="onInputBlur()"></rappider-select>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Button Type
            </nz-form-label>
            <div class="input">
              <rappider-select [(ngModel)]="actionItem.buttonType"
                               [options]="buttonTypeSelectOptions"
                               (blur)="onInputBlur()"></rappider-select>
            </div>
          </div>

          <div class="control-area">
            <nz-form-label class="label">
              Redirect Url
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.redirectUrl"
                                (blur)="onInputBlur()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Disabled
            </nz-form-label>
            <div class="input">
              <rappider-switch [(ngModel)]="actionItem.disabled"
                               (blur)="onInputBlur()"></rappider-switch>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Tooltip Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.tooltipText"
                                (blur)="onInputBlur()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Emit Without Popconfirm
            </nz-form-label>
            <div class="input-emit-without">
              <rappider-switch [(ngModel)]="actionItem.emitWithoutPopconfirm"
                               (blur)="onInputBlur()"></rappider-switch>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Title
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.popconfirmTitle"
                                (blur)="onInputBlur()"></rappider-textbox>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Ok Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.popconfirmOkText"
                                (blur)="onInputBlur()"></rappider-textbox>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Cancel Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.popconfirmCancelText"
                                (blur)="onInputBlur()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Icon
            </nz-form-label>
            <div class="input">
              <rappider-icon-picker-wrapper [(ngModel)]="actionItem.icon"
                                            (blur)="onInputBlur()"></rappider-icon-picker-wrapper>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Placement
            </nz-form-label>
            <div class="input">
              <rappider-select [(ngModel)]="actionItem.popconfirmPlacement"
                               [options]="popConfirmPlacementTypeSelectableOption"
                               (blur)="onInputBlur()"></rappider-select>
            </div>
          </div>
        </div>

        </div>
      </ng-container>
      <ng-template #descriptionTmpl>
      <div class="short-description">
        <div class="drag-icon" *ngIf="!hideDragIcon">
          <i class="fa-regular fa-grip-lines"></i>
        </div>
        <div class="description">
          <ng-container *ngIf="actionItem.name">
            <span><b>Name:</b></span> {{actionItem.name}}
            <ng-container *ngIf="actionItem.text">
            </ng-container>
          </ng-container>
          <ng-container *ngIf="actionItem.text">
            <span><b>Text:</b></span> {{actionItem.text}}
            <ng-container *ngIf="actionItem.behavior">
            </ng-container>
          </ng-container>
          <ng-container *ngIf="actionItem.behavior">
            <span><b>Behavior:</b></span> {{ActionBehavior[actionItem.behavior]}}
          </ng-container>
        </div>
      </div>
      <div class="delete-edit-buttons">
        <div class="edit-button">
          <rappider-button [icon]="editButtonIconConfig"
                           size="small"
                           (click)="onEditItemClick(i)"></rappider-button>
        </div>
        <div *ngIf="showVisibilityToggle" class="visibility-button">
          <rappider-button [icon]="isActionVisible(actionItem) ? visibilityOnIconConfig : visibilityOffIconConfig"
                           size="small"
                           [tooltipText]="isActionVisible(actionItem) ? 'Hide' : 'Show'"
                           (click)="onVisibilityToggleClick(i)"></rappider-button>
        </div>
        <div *ngIf="!hideDeleteButton && !customDeleteAction">
          <rappider-button [icon]="deleteButtonIconConfig"
                           size="small"
                           popconfirmTitle="Are you sure to delete this item?"
                           [emitWithoutPopconfirm]="false"
                           (confirm)="onDeleteItemClick(i)">
          </rappider-button>
        </div>
        <div *ngIf="!hideDeleteButton && customDeleteAction" class="custom-delete-button">
          <rappider-button [icon]="deleteButtonIconConfig"
                           size="small"
                           [tooltipText]="'Remove'"
                           (click)="onDeleteItemClick(i)">
          </rappider-button>
        </div>
      </div>
      </ng-template>
    </section>
  </div>
</ng-container>

<ng-container *ngIf="hideDragIcon">
  <section *ngFor="let actionItem of value; let i = index"
           class="config-edit-area">
    <ng-container *ngIf="actionItem.isEditing; else descriptionTmplNoDrag">
      <div class="form-area">
        <div class="form-header-actions">
          <div class="form-header-left">
            <div *ngIf="showVisibilityToggle" class="visibility-button">
              <rappider-button [icon]="isActionVisible(actionItem) ? visibilityOnIconConfig : visibilityOffIconConfig"
                               size="small"
                               [tooltipText]="isActionVisible(actionItem) ? 'Hide' : 'Show'"
                               (click)="onVisibilityToggleClick(i)"></rappider-button>
            </div>
          </div>
          <div class="form-header-right">
            <rappider-button [icon]="collapseIconConfig"
                             size="small"
                             [tooltipText]="'Collapse'"
                             (click)="onCollapseClick(i)"></rappider-button>
          </div>
        </div>
        <div class="config-input-area">
          <div class="control-area">
            <nz-form-label nzRequired>
              Name
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.name"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
              <small *ngIf="tempValueSubmitted && !actionItem.name"
                     class="error">*This field can't be empty</small>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label>
              Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.text"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Behavior
            </nz-form-label>
            <div class="input">
              <rappider-select [(ngModel)]="actionItem.behavior"
                               [options]="behaviorSelectOptions"
                               (ngModelChange)="onInputChange()"></rappider-select>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Button Type
            </nz-form-label>
            <div class="input">
              <rappider-select [(ngModel)]="actionItem.buttonType"
                               [options]="buttonTypeSelectOptions"
                               (ngModelChange)="onInputChange()"></rappider-select>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Redirect Url
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.redirectUrl"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Disabled
            </nz-form-label>
            <div class="input">
              <rappider-switch [(ngModel)]="actionItem.disabled"
                               (ngModelChange)="onInputChange()"></rappider-switch>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Tooltip Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.tooltipText"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Emit Without Popconfirm
            </nz-form-label>
            <div class="input-emit-without">
              <rappider-switch [(ngModel)]="actionItem.emitWithoutPopconfirm"
                               (ngModelChange)="onInputChange()"></rappider-switch>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Title
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.popconfirmTitle"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Ok Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.popconfirmOkText"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Cancel Text
            </nz-form-label>
            <div class="input">
              <rappider-textbox [(ngModel)]="actionItem.popconfirmCancelText"
                                (ngModelChange)="onInputChange()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <nz-form-label class="label">
              Icon
            </nz-form-label>
            <div class="input">
              <rappider-icon-picker-wrapper [(ngModel)]="actionItem.icon"
                                            (ngModelChange)="onInputChange()"></rappider-icon-picker-wrapper>
            </div>
          </div>
          <div *ngIf="!actionItem.emitWithoutPopconfirm"
               class="control-area">
            <nz-form-label class="label">
              Popconfirm Placement
            </nz-form-label>
            <div class="input">
              <rappider-select [(ngModel)]="actionItem.popconfirmPlacement"
                               [options]="popConfirmPlacementTypeSelectableOption"
                               (ngModelChange)="onInputChange()"></rappider-select>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #descriptionTmplNoDrag>
      <div class="short-description">
        <div class="description">
          <ng-container *ngIf="actionItem.name">
            <span><b>Name:</b></span> {{actionItem.name}}
            <ng-container *ngIf="actionItem.text">
            </ng-container>
          </ng-container>
          <ng-container *ngIf="actionItem.text">
            <span><b>Text:</b></span> {{actionItem.text}}
            <ng-container *ngIf="actionItem.behavior">
            </ng-container>
          </ng-container>
          <ng-container *ngIf="actionItem.behavior">
            <span><b>Behavior:</b></span> {{ActionBehavior[actionItem.behavior]}}
          </ng-container>
        </div>
      </div>
      <div class="delete-edit-buttons">
        <div class="edit-button">
          <rappider-button [icon]="editButtonIconConfig"
                           size="small"
                           (click)="onEditItemClick(i)"></rappider-button>
        </div>
        <div *ngIf="showVisibilityToggle" class="visibility-button">
          <rappider-button [icon]="isActionVisible(actionItem) ? visibilityOnIconConfig : visibilityOffIconConfig"
                           size="small"
                           [tooltipText]="isActionVisible(actionItem) ? 'Hide' : 'Show'"
                           (click)="onVisibilityToggleClick(i)"></rappider-button>
        </div>
        <div *ngIf="!hideDeleteButton && !customDeleteAction">
          <rappider-button [icon]="deleteButtonIconConfig"
                           size="small"
                           popconfirmTitle="Are you sure to delete this item?"
                           [emitWithoutPopconfirm]="false"
                           (confirm)="onDeleteItemClick(i)">
          </rappider-button>
        </div>
        <div *ngIf="!hideDeleteButton && customDeleteAction" class="custom-delete-button">
          <rappider-button [icon]="deleteButtonIconConfig"
                           size="small"
                           [tooltipText]="'Remove'"
                           (click)="onDeleteItemClick(i)">
          </rappider-button>
        </div>
      </div>
    </ng-template>
  </section>
</ng-container>

<!-- Show empty box when no actions and hideAddButton is true -->
<ng-container *ngIf="hideAddButton && showVisibilityToggle && (!value || value.length === 0)">
  <section class="config-edit-area">
    <div class="short-description">
      <div class="description">
        <span style="color: var(--text-color-secondary); font-style: italic;">No action configured</span>
      </div>
    </div>
    <div class="delete-edit-buttons">
      <div class="visibility-button">
        <rappider-button [icon]="visibilityOffIconConfig"
                         size="small"
                         [tooltipText]="'Show'"
                         (click)="onEmptyBoxVisibilityClick()"></rappider-button>
      </div>
    </div>
  </section>
</ng-container>

<rappider-button *ngIf="!hideAddButton"
                 text="Add Action"
                 (click)="addAction()"></rappider-button>
